import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthFacade } from 'app/store/auth.facade';
import { HttpActionState } from '../../users/userslisting/store/users-listing.reducers';
import { AuthHelperService } from 'app/auth/helpers/auth-helper.service';
import { AuthenticationService } from 'app/auth/service';
import { GlobalService } from 'app/global/global.service';
import { TranslocoService } from '@jsverse/transloco';
import { ValidationPatterns } from 'app/constants/constants';

export interface IOtpForm {
  otp: string;
}

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.scss'
})

export class VerifyOtpComponent implements OnInit {
  
  public verificationForm: FormGroup;
  public loading: boolean = false;
  public submitted: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _authFacade: AuthFacade,
    private authHelper: AuthHelperService,
    private _authService: AuthenticationService,
    private _globalService: GlobalService,
    private _translocoService: TranslocoService
  ) {  this.authHelper.setLayoutConfig(true, false, true); }

  ngOnInit(): void {
    this.initVerificationForm();
  }





  /**
   * Initializes the verification form with validation rules.
   * The form contains a single control 'otp' which is required and must be a 6-digit number.
   * 
   * @private
   */
  private initVerificationForm(): void {
    this.verificationForm = this._formBuilder.group({
      otp: ['', [Validators.required, Validators.pattern(ValidationPatterns.OTP)]],
    });
  }


  /**
   * Getter for the controls of the verification form.
   * 
   * @returns {AbstractControl} The controls of the verification form.
   */
  get form() {
    return this.verificationForm.controls;
  }



  /**
   * Handles the completion of the OTP code input.
   * 
   * This method is triggered when the OTP code input is fully entered by the user.
   * It sets the value of the 'otp' field in the verification form to the provided event value.
   * 
   * @param $event - The completed OTP code entered by the user.
   */
  onCodeCompleted($event: number): void {
    this.verificationForm.get('otp')?.setValue($event);
    this.verifyOTP();
  }




  /**
   * Verifies the OTP (One-Time Password) entered by the user.
   * 
   * This method sets the `submitted` flag to true and checks if the 
   * verification form is invalid. If the form is invalid, the method 
   * returns early. If the form is valid, it sets the `loading` flag to true.
   * 
   * @returns {void}
   */
  verifyOTP(): void {
    this.submitted = true;
    if(this.verificationForm.invalid) {
      return;
    } 
    this.loading = true;
    this._authFacade.verifyOtp(this.verificationForm.value.otp);
    this._authFacade.verifyOtpInProgress$.subscribe((verifyOtpInProgress) => {
      if(verifyOtpInProgress === HttpActionState.Done || verifyOtpInProgress === HttpActionState.Failed) {
        this.loading = false;
        this.submitted = false;
      }
    });
  }



  resendOtp(): void {
    this._authService.resendOtp().subscribe({
      next: () => this._globalService.toastrSuccess(
        this._translocoService.translate('OTP successully sent toaster message (Otp verification page) - OTP successully sent')
      ),
      error: (error) => this._globalService.toastrError(error)
    });
  }
}